import React from "react";
import { Col, Row } from "react-bootstrap";
import { ReportIssue } from "../components/Sidebar/General/ReportIssue";
import { Volunteering } from "../components/Sidebar/General/Volunteering";
import { BecomeAMember } from "../components/Sidebar/General/BecomeAMember";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../utils/utils";

import {
  StyledTitle,
  StyledListContainer,
  StyledListSection,
  ListItemText,
  StyledIntro,
  StyledBody,
  StyledBodySectionHeader,
  StyledSectionHeaderComponent,
} from "../utils/common-styles";


export const PrivacyPolicy = (props) => {

  return (
    <>
      <Helmet>
        <title>The Friends of Queen's Wood</title>
        <meta name="description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="The Friends of Queen's Wood" />
        <meta property="og:description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content="The Friends of Queen\'s Wood" />
        <meta name="twitter:description" content="The Friends of Queen\'s Wood is a group of volunteers that help look after the wood" />
        <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="Privacy Policy" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>

              <ListItemText>
                <StyledTitle>Privacy Policy</StyledTitle>
              </ListItemText>

              <StyledIntro>
                This privacy policy sets out how the Friends of Queen’s Wood uses and protects any information that you give the Friends of Queen’s Wood when you use this website.
              </StyledIntro>
              <StyledBody>
                <p>
                  The Friends of Queen’s Wood is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
                </p>
                <p>
                  The Friends of Queen’s Wood may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This policy is effective from 7 May 2018
                </p>
                <StyledBodySectionHeader>
                  What we collect
                </StyledBodySectionHeader>
                <p>
                  We may collect the following information:
                </p>
                <ul>
                  <li>name</li>
                  <li>contact information including address, telephone number and email address.</li>
                </ul>
                <StyledBodySectionHeader>
                  What we do with the information we gather
                </StyledBodySectionHeader>
                <p>
                  We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
                </p>
                <StyledBodySectionHeader>
                  Internal record keeping.
                </StyledBodySectionHeader>
                <p>
                  We may use the information to improve our services.
                </p>
                <p>
                  From time to time, we may also use your information to contact you. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests.
                </p>
                <StyledBodySectionHeader>
                  Security
                </StyledBodySectionHeader>
                <p>
                  We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
                </p>
                <StyledBodySectionHeader>
                  Cookies
                </StyledBodySectionHeader>
                <p>
                  This website does not use cookies. Web statistics and information are collected from the visitor based on the browser information.
                </p>
                <StyledBodySectionHeader>
                  Links to other websites
                </StyledBodySectionHeader>
                <p>
                  Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.
                </p>
                <StyledBodySectionHeader>
                  Controlling your personal information
                </StyledBodySectionHeader>
                <p>
                  We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We will not use your personal information to send you promotional information about third parties.
                </p>
                <p>
                  You may request details of personal information which we hold about you under the Data Protection Act 1998. If you would like a copy of the information held on you please email us <a href="mailto:info@fqw.org.uk">info@fqw.org.uk</a>
                </p>
                <p>
                  If you believe that any information we are holding on you is incorrect or incomplete, please email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.
                </p>
              </StyledBody>
            </Col>
            <Col xs={12} md={3}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <ReportIssue />
              <Volunteering />
              <BecomeAMember />
            </Col>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
